/**
* @Description 文件功能说明：账户 table 组件
* @Author
* @Time 2021/6/4
**/

/* HTML */
<template>
    <div :class="{'table-item-box': true, 'max-box': !showBoxFlag}">
        <section style="height: 100%;" :class="stateClass_keyForm" >
            <!--查询工具条-->
            <el-col style="text-align: left;" v-resize="elFormResize">
                <el-form :inline="true" :model="filters" ref="filters">
                    <el-form-item>
                      查询条件：
                    </el-form-item>
                    <el-form-item prop="groupId">
                        <TreeSelect :data="carGroups" :selectTree="groupSelectTree" @setSelectVal="setSelectVal" ref="treeSelect"/>
                    </el-form-item>
                    <el-form-item prop="keyword">
                        <el-input v-model="filters.keyword" style="width: 300px;" placeholder="请输入车辆类型/车牌号/司机姓名" clearable @keyup.enter.native="researchCars">
                          <i slot="suffix" class="el-input__icon el-icon-search" @click="researchCars"></i>
                        </el-input>
                    </el-form-item>
                    <el-form-item style="float: right;margin-right: 0px;">
                        <el-dropdown split-button type="primary" @click="unbound" trigger="click" >
                            <i class="el-icon-link"></i> 刷卡解绑
                            <el-dropdown-menu slot="dropdown" trigger="click">
                                <el-dropdown-item  icon="el-icon-link" @click.native="unboundBatch">批量解绑</el-dropdown-item>
                                <el-dropdown-item  icon="el-icon-delete" @click.native="deleteBatch">批量删除</el-dropdown-item>
                                <el-dropdown-item v-if="false" icon="el-icon-download" @click.native="download">下载模板</el-dropdown-item>
                                <el-dropdown-item v-if="false" >
                                    <el-upload
                                        ref="uploadCar"
                                        accept=".xlsx,.xls"
                                        :auto-upload="true"
                                        :show-file-list="false"
                                        :before-upload="beforeUpload"
                                        :on-success="uploadSuccess"
                                        :on-error="uploadError"
                                        :action="upload.uploadUrl"
                                        :headers="upload.myHeaders"
                                    >
                                        <i class="el-icon-upload2"></i>批量上传
                                    </el-upload>
                                </el-dropdown-item>
                                <el-dropdown-item v-if="false" icon="el-icon-download" @click.native="exportData">数据导出</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <el-button type="primary" icon="el-icon-connection" trigger="click" @click="addCar">新增车辆</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
            <!-- 表格 -->
            <el-table :data="cars"
                      @sort-change="changeSort"
                      ref="multipleTable"
                      stripe
                      :class="{'table': true, 'no-pagination': false}" style="height: calc(100% - 100px);">
                <el-table-column type="selection"></el-table-column>
                <el-table-column prop="group_id" label="分组" min-width="80px" :sortable="filters.sortable" :sort-orders="filters.sortOrders">
                	<template slot-scope="scope">
                		<span style="white-space: nowrap;" :title="scope.row.groupName">{{scope.row.groupName}}</span>
                	</template>
                </el-table-column>
                <el-table-column prop="car_type" label="类型" min-width="80px" :sortable="filters.sortable" :sort-orders="filters.sortOrders">
                	<template slot-scope="scope">
                		<span style="white-space: nowrap;" :title="scope.row.carType">{{scope.row.carType}}</span>
                	</template>
                </el-table-column>
                <el-table-column prop="car_number" label="车牌号" min-width="100px" :sortable="filters.sortable" :sort-orders="filters.sortOrders">
                    <template slot-scope="scope">
                        <span style="white-space: nowrap;" :title="scope.row.carNumber">{{scope.row.carNumber}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="userName" label="司机" min-width="100px">
                    <template slot-scope="scope">
                        <i v-if="scope.row.sex==1" class="el-icon-male" ></i>
                        <i v-else class="el-icon-female"></i>
                        <span style="white-space: nowrap;" :title="'编号：' + scope.row.idCard + '\n姓名：' + scope.row.userName + '\n性别：' + (scope.row.sex==1?'男':'女')">{{scope.row.userName}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="phone" label="手机号" min-width="120px">
                	<template slot-scope="scope">
                		<span style="white-space: nowrap;" :title="scope.row.phoneCode + ' ' + scope.row.phone">{{ (scope.row.phone==''||scope.row.phone==null)?'':(scope.row.phoneCode + ' ' + scope.row.phone)}}</span>
                	</template>
                </el-table-column>
                <el-table-column prop="tagId" label="绑定标签" min-width="130px">
                	<template slot-scope="scope">
                		<span style="white-space: nowrap;" :title="scope.row.tagId">{{scope.row.tagId}}</span>
                	</template>
                </el-table-column>
                <el-table-column v-if="false" prop="zoneOfAction" label="作业区域" min-width="100px">
                	<template slot-scope="scope">
                		<span style="white-space: nowrap;" :title="scope.row.zoneOfAction">{{scope.row.zoneOfAction}}</span>
                	</template>
                </el-table-column>
                <el-table-column v-if="false" prop="safeDistance" label="安全距离" min-width="100px">
                	<template slot-scope="scope">
                		<span style="white-space: nowrap;" :title="scope.row.safeDistance">{{!$checkEmpty(scope.row.safeDistance) ? (scope.row.safeDistance + '米') : ''}}</span>
                	</template>
                </el-table-column>
                <el-table-column v-if="false" prop="alarmAddr" label="警报地址" min-width="100px">
                	<template slot-scope="scope">
                		<span style="white-space: nowrap;" :title="scope.row.alarmAddr">{{scope.row.alarmAddr}}</span>
                	</template>
                </el-table-column>
                <el-table-column prop="remarks" label="备注" min-width="100px">
                	<template slot-scope="scope">
                		<span style="white-space: nowrap;" :title="scope.row.remarks">{{scope.row.remarks}}</span>
                	</template>
                </el-table-column>
                <el-table-column label="操作" width="180px">
                    <template slot-scope="scope">
                      <el-button-group>
                        <span  class="el-icon-edit" size="mini" @click="()=>{editRow(scope.row, scope.$index)}" trigger="click"  title="编辑"> 编辑</span>
                        <span  class="el-icon-connection" size="mini" @click="()=>{binding(scope.row, scope.$index)}" trigger="click" title="绑定标签" v-if="!scope.row.tagId || scope.row.tagId==''"> 绑定</span>
                        <span  class="el-icon-link" size="mini" @click="()=>{unbundling(scope.row, scope.$index)}" trigger="click" title="解除绑定" v-if="scope.row.tagId && scope.row.tagId!=''"> 解绑</span>
                      </el-button-group>
                    </template>
                </el-table-column>
            </el-table>

            <!--分页工具条-->
            <Pagination
                :currentPage="pagination.currentPage"
                :total="pagination.total"
                :pageSize="pagination.limit"
                @handleSizeChangeSub="handleSizeChangeSub"
                @handleCurrentChangeSub="handleCurrentChangeSub"
            />

            <!-- 添加账户 -->
            <CarDialog ref="carDialog" @setTotal="setTotal" @setRow="setRow" :carGroups="carGroups"/>

            <!-- Excel上传 -->
            <CarUploadDialog ref="carUploadDialog"
                          :uploadUrl="upload.saveUrl"
                          :previewTitle="upload.previewTitle"
                          :previewData="upload.previewData"
                          @reSearch = "researchCars"/>

            <!-- 导出数据 -->
            <el-table :data="exportDatas" id="out-table" style="display: none;">
                <el-table-column prop="groupName" label="车辆分组">
                    <template slot-scope="scope">
                        {{scope.row.groupName}}
                    </template>
                </el-table-column>
                <el-table-column prop="carType" label="车辆类型">
                    <template slot-scope="scope">
                        {{scope.row.carType}}
                    </template>
                </el-table-column>
                <el-table-column prop="carNumber" label="车牌号">
                    <template slot-scope="scope">
                        {{scope.row.carNumber}}
                    </template>
                </el-table-column>
                <el-table-column prop="idCard" label="司机编号">
                    <template slot-scope="scope">
                        {{scope.row.idCard}}
                    </template>
                </el-table-column>
                <el-table-column prop="userName" label="姓名">
                    <template slot-scope="scope">
                        {{scope.row.userName}}
                    </template>
                </el-table-column>
                <el-table-column prop="sex" label="性别">
                    <template slot-scope="scope">
                        {{scope.row.sex==1?'男':'女'}}
                    </template>
                </el-table-column>
                <el-table-column prop="duty" label="职务">
                    <template slot-scope="scope">
                        {{scope.row.duty}}
                    </template>
                </el-table-column>
                <el-table-column prop="phone" label="手机号">
                    <template slot-scope="scope">
                        {{scope.row.phone}}
                    </template>
                </el-table-column>
                <el-table-column prop="tagId" label="绑定标签">
                    <template slot-scope="scope">
                        {{scope.row.tagId}}
                    </template>
                </el-table-column>
                <el-table-column prop="zoneOfAction" label="作业区域">
                    <template slot-scope="scope">
                        {{scope.row.zoneOfAction}}
                    </template>
                </el-table-column>
                <el-table-column prop="safeDistance" label="安全距离（米）">
                    <template slot-scope="scope">
                        {{scope.row.safeDistance}}
                    </template>
                </el-table-column>
                <el-table-column prop="alarmAddr" label="警报地址">
                    <template slot-scope="scope">
                        {{scope.row.alarmAddr}}
                    </template>
                </el-table-column>
                <el-table-column prop="alarmTimer" label="警报时长">
                    <template slot-scope="scope">
                        {{scope.row.alarmTimer}}
                    </template>
                </el-table-column>
                <el-table-column prop="remarks" label="备注">
                    <template slot-scope="scope">
                        {{scope.row.remarks}}
                    </template>
                </el-table-column>
            </el-table>

        </section>
    </div>
</template>

<script>
    import ApiCar from '@/request/api-car'
    import TreeSelect from '@/components/TreeSingleSelect.vue'
    import CarDialog from './CarDialog.vue'
    import Pagination from '@/components/Pagination.vue'
    import store from "@/store";
    import CarUploadDialog from './CarUploadDialog'
    import GlobalFun from "@/global/global-function";
    export default {
        /**
         * @Des 组件名
         * @Auth
         * @Date 2021/6/4
         */
        name: "CarTable",
        /**
         * @Des 数据接收类型
         * @Auth
         * @Date 2021/6/4
         */
        props: {
            /**
             * @Des 展示box
             * @Auth
             * @Date 2021/6/5
             */
            showBoxFlag: {
                type: Boolean,
                default: function (){
                    return true
                }
            },
            /**
             * @Des 车辆组
             * @Auth
             * @Date 2021/6/5
             */
            carGroups: {
                type: Array,
                default: function (){
                    return []
                }
            },
        },
        /**
         * @Des 组件引用
         * @Auth
         * @Date 2021/6/4
         */
        components: {
            // 选择树组件
            TreeSelect,
            // 账户弹窗组件
            CarDialog,
            // 分页组件
            Pagination,
            // 动态表格
            CarUploadDialog
        },
        /**
         * @Des 数据定义
         * @Auth
         * @Date 2021/6/4
         */
        data() {
            return {
				/**
                 * @Des class 区分条件查询表单高度
                 * @Auth
                 * @Date 2021/7/10
                 */
                stateClass_keyForm: '',
                /**
                 * @Des 车辆组树数据
                 * @Auth
                 * @Date 2021/6/4
                 */
                groupSelectTree:{
                    placeholder: '请选择车辆组',
                    keywordFilter: false,
                    showBox: false,
                    childBox: false,
                    parentBox: false,
                },
                /**
                 * @Des 分页数据
                 * @Auth
                 * @Date 2021/6/4
                 */
                pagination:{
                    total: 0,
                    startNum: 0,
                    limit: 20,
                    currentPage: 1
                },
                /**
                 * @Des 查询数据
                 * @Auth
                 * @Date 2021/6/4
                 */
                filters: {
                    groupId: '',
                    keyword: '',
                    orderBy: {
                        "createTime": "desc"
                    },
                    sortOrders: [
                        "ascending",
                        "descending"
                    ],
                    sortable: 'custom'
                },
                // 账户信息集合
                cars: [],
                /**
                 * @Des 上传属性
                 * @Auth 
                 * @Date 17:17 2021/4/30
                 */
                upload:{
                    myHeaders: {
                        token: store.state.token,
                        lang: store.state.lang,
                        loginDevice: store.state.loginDevice
                    },
                    previewTitle:[],
                    previewData:[],
                    uploadUrl: ApiCar.uploadUrlApi,// + '?projectId=' + store.state.currentProjectId,
                    saveUrl: ApiCar.addCarApi
                },
                sexIcon: {
                    '1': '/static_dazzle/images/icon_user_1.png',
                    '2': '/static_dazzle/images/icon_user_2.png',
                },
                /**
                 * @Des 外围添加 span
                 * @Auth
                 * @Date 2021/7/5
                 */
                surroundSpan(value) {
                    return '<span style="white-space: nowrap;" title="'+ value +'">'+ value +'</span>';
                },
                exportDatas: [],
            }
        },
        computed: {
        },
        /**
         * @Des 监听
         * @Auth
         * @Date 2021/6/4
         */
        watch: {
            /**
             * @Des 分页监听
             * @Auth
             * @Date 2021/6/4
             */
            pagination: {
                handler(newVal, oldVal){
                    this.searchCars();
                },
                immediate: true,
                deep:true,
            }
        },
        /**
         * @Des 初始化加载
         * @Auth
         * @Date 2021/6/4
         */
        mounted(){
            // 查询账户信息
            this.searchCars();
            GlobalFun.base64Image(this.sexIcon[1], data => {
                this.sexIcon[1] = data;
            });
            GlobalFun.base64Image(this.sexIcon[2], data => {
                this.sexIcon[2] = data;
            });
        },
        /**
         * @Des 方法定义
         * @Auth
         * @Date 2021/6/4
         */
        methods: {

			/**
             * @Des 监听条件查询表单尺寸
             * @Auth
             * @Date 2021/7/10
             */
            elFormResize(data) {
            	let height = data.height.replace(/px/g, '');
            	height = Math.ceil(height);

            	let className = '';
            	if (height <= 50) {
            		// 一行
            		className = 'keyForm-50';
            	} else if (height <= 100) {
            		// 两行
            		className = 'keyForm-100';
            	};

            	this.stateClass_keyForm = className;
            },

            /**
             * @Des 选择值改变
             * @Auth
             * @Date 2021/6/4
             */
            setSelectVal(val){
                if(val && val.id){
                    this.filters.groupId = val.id;
                    this.$refs['treeSelect'].setSelectVal(val);
                }else{
                    this.filters.groupId = '';
                    this.$refs['treeSelect'].setSelectVal();
                }
                // 改变总数
                this.setTotal(0);
            },

            /**
             * 重新搜索
             * */
            researchCars(){
                this.pagination.total = 0;
                this.pagination.startNum = 0;
                this.pagination.currentPage = 1;
                this.searchCars();
            },

            /**
             * @Des 查询账户信息
             * @Auth
             * @Date 2021/6/4
             */
            searchCars(){
                this.$request.postJsonRequest(ApiCar.searchCarApi,{
                    groupId: this.filters.groupId,
                    keyword: this.filters.keyword,
                    // projectId: this.$store.state.currentProjectId,
                    orderBy: this.filters.orderBy,
                    total: this.pagination.total,
                    startNum: this.pagination.startNum,
                    limit: this.pagination.limit,
                }).then(result => {
                    this.pagination.total = result.total;
                    this.cars = result.rows;
                    // console.log(this.cars)
                }).catch(error => {
                    console.error('查询车辆异常', ApiCar.searchCarApi, error);
                })
            },
            /**
             * @Des 新增账户
             * @Auth
             * @Date 2021/6/4
             */
            addCar() {
            	this.$refs.carDialog.openDialog('新增车辆', '保存添加', 'add');
            },
            /**
             * @Des 编辑账户
             * @Auth
             * @Date 2021/6/21
             */
            editRow(row, index) {
            	this.$refs.carDialog.openDialog('编辑车辆', '保存修改', 'edit', row, index);
            },
            /**
             * @Des 删除账户
             * @Auth
             * @Date 2021/6/21
             */
            deleteRow(row, index){
                this.$confirm(
					'确认删除'+ row.userName +'的'+ row.carNumber +'？','询问',
					{
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						closeOnClickModal : false,
						type: 'warning'
					}
				).then(_ => {
					// 删除账户 交互
					this.requestDelete([row.carId]);
				}).catch(_ => {
					//console.log('cancel')
				});
            },

            /**
             * @Des 批量删除
             * @Auth
             * @Date 2021/6/21
             */
            deleteBatch(){
                let data = this.$refs.multipleTable.selection;
                const ids = [];
                data.forEach((row, index) => {
                    ids.push(row.carId);
                })
                if(ids.length == 0){
                    this.$message({
                        message: '请选择要删除的数据！',
                        type: 'warning',
                        showClose: true,
                        dangerouslyUseHTMLString: true
                    });
                    return false;
                }
                this.$confirm(
                    '确认批量删除车辆吗？','询问',
                    {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        closeOnClickModal : false,
                        type: 'warning'
                    }
                ).then(_ => {
                    // 删除账户 交互
                    this.requestDelete(ids);
                }).catch(_ => {
                    //console.log('cancel')
                });
            },
            /**
             * @Des 删除账户 交互
             * @Auth
             * @Date 2021/6/21
             */
            requestDelete(carIds) {
            	this.$request.postJsonRequest(ApiCar.deleteCarApi,{
                    carIds: carIds,
                    // projectId: this.$store.state.currentProjectId
                }).then(result => {
                    if(result.code == 0){
                        this.$message({
                            message: '删除成功',
                            type: 'success',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                        // 改变总数
                        this.setTotal(0);

                    }else{
                        this.$message({
                            message: '正在绑定标签的车辆不能删除，请解除绑定后再删除！',
                            type: 'error',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                    }
                }).catch(error => {
                    console.error('删除车辆异常', ApiCar.deleteCarApi, error);
                })
            },

            /**
             * 绑定
             * */
            binding(row, index){
                this.$refs.carDialog.openDialog('绑定标签', '绑定标签', 'binding',row, index);
            },

            /**
             *  批量解绑
             * */
            unboundBatch(){
                let data = this.$refs.multipleTable.selection;
                const ids = [];
                data.forEach((row, index) => {
                    ids.push(row.carId);
                })
                if(ids.length == 0){
                    this.$message({
                        message: '请选择要解绑的数据！',
                        type: 'warning',
                        showClose: true,
                        dangerouslyUseHTMLString: true
                    });
                    return false;
                }
                this.$confirm(
                    '确认批量解绑用户吗？','询问',
                    {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        closeOnClickModal : false,
                        type: 'warning'
                    }
                ).then(_ => {
                    // 解绑车辆 交互
                    this.$request.postJsonRequest(ApiCar.unboundCarApi,{
                        carIds: ids,
                    }).then(result => {
                        if(result.code == 0){
                            this.$message({
                                message: '批量解绑成功',
                                type: 'success',
                                showClose: true,
                                dangerouslyUseHTMLString: true
                            });
                        }else{
                            this.$message({
                                message: result.msg,
                                type: 'error',
                                showClose: true,
                                dangerouslyUseHTMLString: true
                            });
                        }
                        this.searchCars();
                    }).catch(error => {
                        console.error('批量解绑车辆异常', ApiCar.unboundCarApi, error);
                    })
                }).catch(_ => {
                    //console.log('cancel')
                });
            },

            /**
             * 解除绑定
             * */
            unbound(){
                this.$refs.carDialog.openDialog('解绑标签','解绑标签', 'unbound');
            },

            /**
             * @Des 解绑
             * @Auth
             * @Date 2021/6/21
             */
            unbundling(data,index){
                this.$confirm(
                    '确认要解绑标签【'+data.tagId+'】吗？','询问',
                    {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        closeOnClickModal : false,
                        type: 'warning'
                    }
                ).then(_ => {
                    this.$request.postJsonRequest(ApiCar.unboundCarApi,{
                        carIds: [data.carId],
                    }).then(result => {
                        if(result.code == 0){
                            this.$message({
                                message: '解绑成功',
                                type: 'success',
                                showClose: true,
                                dangerouslyUseHTMLString: true
                            });
                            // 改变行值
                            data.tagId = '';
                            this.setRow(data, index);

                        }else{
                            this.$message({
                                message: '解绑失败',
                                type: 'error',
                                showClose: true,
                                dangerouslyUseHTMLString: true
                            });
                        }
                    }).catch(error => {
                        console.error('解绑车辆异常', ApiCar.unboundCarApi, error);
                    })
                }).catch(_ => {
                    //console.log('cancel')
                });
            },


            /**
             * @Des 改变总数
             * @Auth
             * @Date 2021/6/21
             */
            setTotal(val){
                this.pagination.total = val;
                if(val == 0){
                    this.pagination.currentPage = 1;
                    this.pagination.startNum = 0;
                }
                // 查询list
                this.searchCars();
            },
            /**
             * @Des 更新列表
             * @Auth
             * @Date 2021/6/21
             */
            setRow(row, index){
                this.cars[index].carType = row.carType;
                this.cars[index].carNumber = row.carNumber;
                this.cars[index].userId = row.userId;
                this.cars[index].userName = row.userName;
                this.cars[index].idCard = row.idCard;
                this.cars[index].phone = row.phone;
                this.cars[index].sex = row.sex;
                this.cars[index].tagId = row.tagId;
                this.cars[index].groupId = row.groupId;
                this.cars[index].groupName = row.groupName;
                this.cars[index].zoneOfAction = row.zoneOfAction;
                this.cars[index].safeDistance = row.safeDistance;
                this.cars[index].alarmAddr = row.alarmAddr;
                this.cars[index].alarmTimer = row.alarmTimer;
                this.cars[index].remarks = row.remarks;
            },

            /**
             * @Des 当前页数据改变
             * @Auth
             * @Date 2021/6/4
             */
            handleCurrentChangeSub(val){
                this.pagination.currentPage = val;
                this.pagination.startNum = this.pagination.limit * (val-1);
            },
            /**
             * @Des 页长度改变
             * @Auth
             * @Date 2021/6/4
             */
            handleSizeChangeSub(val){
                this.pagination.limit = val;
                this.pagination.currentPage = 1;
                this.pagination.startNum = 0;
            },
            /**
             * @Des 下载模板
             * @Auth
             * @Date 2021/6/4
             */
            download(){
                // 下载模板
                // 文件名
                let fileName = '车辆上传模板.xlsx';
                // 资源文件下载 至本地
                GlobalFun.downloadFile(ApiCar.carUploadModel, fileName);
            },
            /**
             * @Des 上传之前的处理
             * @Auth 
             * @Date 17:20 2021/4/30
             */
            beforeUpload(file){
                // 上传之前
                // console.log(file)
                this.upload.previewTitle = [];
                this.upload.previewData = [];
                let extension = file.name.substring(file.name.lastIndexOf('.')+1);
                let size = file.size/1024/1024;
                // console.log(extension, size)
                if(extension !== 'xlsx') {
                    this.$message.warning('只能上传后缀是.xlsx的文件');
                }
                if(size > 10) {
                    this.$message.warning('文件大小不得超过10M');
                }
            },

            /**
             * @Des 上传成功后的处理
             * @Auth 
             * @Date 17:20 2021/4/30
             */
            uploadSuccess(res, file, fileList) {
                // 上传成功
                // console.log(res, file, fileList);
                // console.log(this.upload.fileType)
                if(res.code == 0){
                    // 返回数据
                    // console.log(res.data)
                    // 显示车辆列表信息
                    this.upload.previewTitle.push({
                        label: '车辆类型',
                        prop: 'carType',
                        width: '100px'
                    });
                    this.upload.previewTitle.push({
                        label: '车牌号',
                        prop: 'carNumber',
                        width: '100px'
                    });
                    this.upload.previewTitle.push({
                        label: '司机编号',
                        prop: 'idCard',
                        width: '150px'
                    });
                    this.upload.previewTitle.push({
                        label: '绑定标签',
                        prop: 'tagId',
                        width: '150px'
                    });
                    this.upload.previewTitle.push({
                        label: '作业区域',
                        prop: 'zoneOfAction',
                        width: '100px'
                    });
                    this.upload.previewTitle.push({
                        label: '安全距离',
                        prop: 'safeDistance',
                        width: '100px'
                    });
                    this.upload.previewTitle.push({
                        label: '警报地址',
                        prop: 'alarmAddr',
                        width: '100px'
                    });
                    this.upload.previewTitle.push({
                        label: '警报时长',
                        prop: 'alarmTimer',
                        width: '100px'
                    });
                    this.upload.previewTitle.push({
                        label: '备注',
                        prop: 'remarks',
                        width: '100px'
                    });
                    this.upload.previewTitle.push({
                        label: '信息',
                        prop: 'message',
                    })
					
                    res.data.forEach((row, index) => {
                        let _row = {
                            carType: row.carType,
                            carNumber: row.carNumber,
                            idCard: row.idCard,
                            userId: row.userId,
                            tagId: row.tagId,
                            zoneOfAction: row.zoneOfAction,
                            safeDistance: row.safeDistance,
                            alarmAddr: row.alarmAddr,
                            alarmTimer: row.alarmTimer,
                            remarks: row.remarks,
                            code: row.code,
                            message: row.message,
                            disabled: row.code==0?false:true,
                            checked: row.code==0?true:false,
                        }

                        let _row_ = {};
                        for (let i in _row) {
                            // 外围添加 span
                            _row_[i + 'Span'] = this.surroundSpan(_row[i]==null?"":_row[i]);
                        };

                        this.upload.previewData.push(Object.assign({}, _row, _row_));
                    })

                    if(this.upload.previewData.length > 0){
                        //弹出预览
                        this.$refs.carUploadDialog.openDialog("车辆上传预览", "确定上传");
                    }
                    // console.log(res.data)
                }else{
                    this.$message({
                        type: 'error',
                        message: res.msg ,
                        dangerouslyUseHTMLString: true
                    });
                }
            },

            /**
             * @Des 上传失败后的处理
             * @Auth 
             * @Date 17:20 2021/4/30
             */
            uploadError(err, file, fileList) {
                // 上传失败
                this.$message({
                    type: 'error',
                    message: err.msg ,
                    dangerouslyUseHTMLString: true
                });
            },

            /**
             * @Des 查询车辆信息, 并导出
             * @Auth
             * @Date 2021/6/4
             */
            exportData(){
                this.$request.postJsonRequest(ApiCar.exportApi,{
                    groupId: this.filters.groupId,
                    keyword: this.filters.keyword,
                    // projectId: this.$store.state.currentProjectId,
                    orderBy: this.filters.orderBy
                }).then(result => {
                    this.exportDatas = [];
                    if(result.total > 0){
                        this.exportDatas = result.rows;
                    }
                    if(this.exportDatas.length == 0){
                        this.$message({
                            message: '无数据导出',
                            type: 'error',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                        return false;
                    }
                    this.$nextTick(() => {
                        GlobalFun.exportExcel(document.querySelector("#out-table"),'车辆信息.xlsx');
                    });
                }).catch(error => {
                    console.error('导出车辆异常', ApiCar.exportApi, error);
                })
            },
            /**
             * 改变排序
             * */
            changeSort(data){
                let prop = data.prop;
                let order = data.order;
                if(order == null){
                    order = this.filters.orderBy[prop];
                }else{
                    order = order.replace("ending", "");
                }
                if(order != null){
                    this.filters.orderBy = {};
                    this.filters.orderBy[prop] = order;
                }
                this.researchCars();
            }
        },
    }
</script>
/* JS */

/* CSS */
<style lang="scss" scoped>
	
</style>



// WEBPACK FOOTER //
// src/components_pages/Car/CarTable.vue